
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogArticle",
      function () {
        return require("private-next-pages/blogArticle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogArticle"])
      });
    }
  